import {TOKENS} from "../../../constants/tokens";

export const calculateBlockedConstructionCellsForRoads = (hexes, availableConstructionCells) => {
  const availableSet = new Set(availableConstructionCells);
  const blockedCells = new Set();

  availableSet.forEach(cellKey => {
    if (hexes[cellKey] === TOKENS.ROAD) {
      blockedCells.add(cellKey);
    }
  })

  return blockedCells;
};
